// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Toastr, Button } from "../../../../revvComponents";

// Components Imports
import TempWFConditionsList from "./TempWFConditionsList";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

// Internals imports
import { TEMPLATE } from "../../../../constants";

// Destructuring
const { updateTempWorkFlowData, nukeTempRuleSet } = DocumentTemplateActions;
const { DYNAMIC_FIELD_OPTIONS } = TEMPLATE;

// Declarations
const DF_CONDITION_OBJECT = {
  param: "",
  rel_op: "",
  value: "",
};
const CLS_CONDITION_OBJECT = {
  param: "",
  rel_op: "",
  sub_param: "",
  value: "",
};

class TempWFConditions extends Component {
  _updateState = newState => {
    this.props.updateTempWorkFlowData(
      "tempWFCondition",
      newState,
      this.props.index,
    );
  };

  _onAddCondition = type => {
    const cloneState = Object.assign({}, this.props.tempWFCondition);
    let isNotEmpty = true;

    // CHECK IF THE LAST CONDITION VALUES IS NOT EMPTY
    if (cloneState.conditions.length > 0) {
      const lastRowIndex = cloneState.conditions.length - 1;
      isNotEmpty = Object.values(cloneState.conditions[lastRowIndex]).every(
        value => value !== "",
      );
    }

    // ACTIONS BASED ON ABOVE CONDITION
    if (isNotEmpty) {
      const { entity } = this.props;
      let condObj;
      if (type === "CLAUSE") {
        const fieldType = this._getClauseField().meta.subtype;
        let relOp;
        let subParam;
        if (
          fieldType === "single_select" ||
          fieldType === "multi_select" ||
          fieldType === "optional"
        ) {
          relOp = "==";
          subParam = "id";
        } else if (fieldType === "free_text") {
          relOp = "!=";
          subParam = "value";
        }
        condObj = {
          ...CLS_CONDITION_OBJECT,
          param: entity.dynamicFieldId,
          rel_op: relOp,
          sub_param: subParam,
        };
      } else if (entity.type === "DYNAMICFIELD") {
        const fieldType = DYNAMIC_FIELD_OPTIONS[this._getClauseField().type];
        let relOp;
        if (fieldType === "single_select") {
          relOp = "==";
        }
        condObj = {
          ...DF_CONDITION_OBJECT,
          param: entity.dynamicFieldId,
          rel_op: relOp,
        };
      }
      cloneState.conditions.push({ ...condObj });
      this._updateState(cloneState);
    } else {
      Toastr.showToastr({
        type: "warning",
        message: "Please fill in the required fields.",
        timeout: 3000,
      });
    }
  };

  _onRemoveCondition = index => {
    const cloneState = Object.assign({}, this.props.tempWFCondition);
    if (cloneState.conditions.length === 1) {
      this.props.nukeTempRuleSet(this.props.index);
    } else {
      cloneState.conditions.splice(index, 1);
      this._updateState(cloneState);
    }
  };

  _onInputChange = (field, event, index, isNumField) => {
    const value = String(isNumField ? event : event.target.value);
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.tempWFCondition);
      cloneState.conditions[index][field] = value;
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  _onSelectChange = (field, value, index) => {
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.tempWFCondition);
      cloneState.conditions[index][field] = value;
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  _getClauseField = () =>
    this.props.fields.find(
      dfield => dfield.id === this.props.entity.dynamicFieldId,
    ) || "";

  _toggleLogicalOperatorVisibility = () => {
    const cloneState = Object.assign({}, this.props.tempWFCondition);
    cloneState.showOperators = !cloneState.showOperators;
    this._updateState(cloneState);
  };

  _getTriggerConditionBtn = () => {
    const {
      tempWFCondition: { conditions },
      entity: { type },
    } = this.props;
    if (!conditions.length > 0) {
      return (
        <Fragment>
          {/* SECTION TO DISPLAY EMPTY MESSAGE */}
          <div className="wfconditions-empty-section">
            <div className="wfconditions-empty-info">
              Your workflow doesn&apos;t have conditions yet. Select an trigger
              from below
            </div>
          </div>

          {/* SECTION TO SET CONDITIONS FOR PRICEBOOK OR SKU LEVEL */}
          <div className="wfconditions-approval-section">
            <div className="wfconditions-section-title">Suggested Triggers</div>
            <div
              className="wfconditions-approval-wrapper"
              onClick={() => this._onAddCondition(type)}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <div className="wfconditions-approval-title">
                <span className="wfconditions-expand-ico">
                  <FontAwesomeIcon icon={["far", "plus"]} />
                </span>
                <span>Add Condition</span>
              </div>
            </div>
          </div>
        </Fragment>
      );
    }
    return null;
  };

  _getTempConditionsList = () => {
    const {
      tempWFCondition: { conditions },
      entity: { type },
    } = this.props;

    const { meta: { subtype } = {} } = this._getClauseField();
    if (conditions.length > 0) {
      return (
        <div className="tempwfconditions-trigger-section">
          <div className="wfconditions-trigger-body">
            {conditions.map((wfCondition, index) => (
              <TempWFConditionsList
                key={wfCondition.id || index}
                index={index}
                data={wfCondition}
                fieldData={this._getClauseField()}
                tempWFCondition={this.props.tempWFCondition}
                onInputChange={this._onInputChange}
                onRemoveCondition={this._onRemoveCondition}
                onSelectChange={this._onSelectChange}
                toggleLogicalOperatorVisibility={
                  this._toggleLogicalOperatorVisibility
                }
              />
            ))}
          </div>
          {subtype !== "free_text" && (
            <div className="wfconditions-add-wrapper">
              <Button
                className="revv-btn-secondary-sm"
                onClick={() => this._onAddCondition(type)}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0"
                data-test="temowfconditions-add-condition-btn">
                <FontAwesomeIcon icon={["far", "plus"]} /> Add another Condition
              </Button>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  render() {
    return (
      <div className="wfconditions-wrapper">
        {/* COMMON TITLE SECTION FOR THE FLOW */}
        <div className="wfconditions-title-section">
          <div className="wfconditions-icon">
            <FontAwesomeIcon icon={["fas", "tasks"]} />
          </div>
          <div className="wfconditions-info">
            <div className="wfconditions-title">Conditions</div>
            <div className="wfconditions-subtitle">
              Select conditions which will trigger this workflow
            </div>
          </div>
        </div>
        {!this.props.isCollapsed && (
          <div>
            {this._getTriggerConditionBtn()}
            {this._getTempConditionsList()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    dynamicFields: { fields },
    workflow: { entity },
  } = state.TemplateStore;

  return {
    entity,
    fields,
  };
};

const mapDispatchToProps = {
  updateTempWorkFlowData,
  nukeTempRuleSet,
};

export default connect(mapStateToProps, mapDispatchToProps)(TempWFConditions);
